




























































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import edit from "./MerchantsEdit.vue";
import BalanceAdjustOrderEdit from "../MerchantBalanceAdjustOrder/BalanceAdjustOrderEdit.vue";
import AdvanceMoneyAdjustOrdersEdit from "@/views/MerchantManage/AdvanceMoneyAdjustOrders/AdvanceMoneyAdjustOrdersEdit.vue";
import MerchantStatistics from "@/views/MerchantManage/Merchants/MerchantStatistics.vue"
import QRCode from 'qrcode';
@Component({
  components: { edit, BalanceAdjustOrderEdit, AdvanceMoneyAdjustOrdersEdit, MerchantStatistics },
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.MerchantServiceProxy();
  }
  options3 = {
    disabledDate(date) {
      return (
        date &&
        (date.valueOf() < Date.now() - 86400000 * 2 ||
          date.valueOf() > Date.now())
      );
    },
  };
  merchantStatisticsShow = false;
  input: proxy.MerchantPageInputDto = new proxy.MerchantPageInputDto();
  testladanshow = false;
  sub_id = 0;
  loginwhiteid = 0;
  isCopyMerRateShow = false;
  createOrEditShow = false;
  AdvanceMoneyAdjustOrdersEditshow = false;
  BalanceAdjustOrderEditshow = false;
  copymerchantids = [];
  merchantId = 0;
  MerLoginWhiteIp: proxy.MerchantLoginWhiteLimitDto = new proxy.MerchantLoginWhiteLimitDto();
  testladanreq = new proxy.CreatePayOrderInputDto();
  marchants: any[] = [];
  all_merchants = [];
  ctypes: any[] = [];
  agents: any[] = [];
  merquntiecodeshow= false;
  mershouyintaicode = "";
  testladanres = "";
  canvasRef = null;
  allchannels = [];
  qlShow = false;
  loginWhiteShow = false;
  googlecode = '';
  groupMark = '';
  apidocshow = false;
  apidocmodel = new proxy.MerchantApidocDto();
  ladanres = new proxy.OrderSubmitPlatOutDto();
  total = new proxy.MerchantTotalOutDto();
  Settlementshow = false;
  settlementreq = new proxy.SettlementPreMerInputDto();
  settlementPredatas = new proxy.SettlementPreOutDto();
  pageSize = 50;
  selectctchannels:any[]=[];
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: "名称",
      slot: "merchantName",
      width: 140,
      fixed: "left",
    },
    {
      title: "商户号",
      key: "mid",
      width: 110,
    },
    {
      title: "登录账号",
      key: "userName",
      width: 130,
    },
    {
      title: "余额",
      slot: "balance",
      width: 150,
      sortable: "custom",
    },
    {
      title: "预付款",
      slot: "advanceMoney",
      width: 150,
      sortable: "custom",
    },
    {
      title: "实时余额",
      slot: "realBalance",
      width: 130,
    },
    {
      title: "状态",
      slot: "status",
      width: 100,
    },
    {
      title: "商户登录加白权限",
      slot: "isLoginWhiteLimit",
      width: 150
    },

    // {
    //   title: "提现服务费",
    //   slot: "withdrawMethod",
    //   width: 250,
    // },
    {
      title: '开通产品',
      slot: 'merchantChannelTypes',
      width: 300
    },
    {
      title: "代理",
      key: "agentName",
      width: 120,
    },
    {
      title: '备注',
      key: 'comment',
      width: 150
    },
    {
      title: '群标志',
      key: 'groupFlag',
      width: 100
    },
    {
      title: "API接口状态",
      slot: "isEnableApi",
      width: 120,
    },
    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
    },
    {
      title: "操作",
      slot: "oper",
      width: 150,
      fixed: "right",
    },
  ];
  CopyMerRateSave(){
    var copymerchanrates = new proxy.CopyMerchantRateInputDto();
    copymerchanrates.merchantId = this.selectedDataItems[0].id;
    copymerchanrates.merchantIds = this.copymerchantids;
    this.prox.copyMerchantRate(copymerchanrates).then(()=>{
      this.$Notice.success({title:'商户费率粘贴成功'})
      this.getpage();
    }).finally(()=>{
      this.copymerchantids=[];
      this.isCopyMerRateShow = false;
    })
  }
  CopyMerRate(){
    if(this.selectedDataItems.length == 0)
    {
      this.$Notice.error({title:"请选择想要复制的商户"});
      return;
    }
    if(this.selectedDataItems.length > 1){
      this.$Notice.error({title:"复制费率对象只能选择一个"});
      return;
    }
    this.isCopyMerRateShow = true;
  }
  showmtype(row) {
    this.$set(row, 'isshow', !row.isshow);

  }
  sortchange(a) {
    if (a.order == "desc") {
      this.sorting = (a.column.slot || a.column.key) + " desc, id desc";
    }
    if (a.order == "asc") {
      this.sorting = (a.column.slot || a.column.key) + " asc, id desc";
    }
    if (a.order == "normal") {
      this.sorting = "Status asc,id desc";
    }
    this.getpage();
  }
  balanceReset() {
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.googleCodeVerify(this.googlecode, req).then(x => {
      this.$Notice.success({ title: "操作成功" });
      this.getpage();
      this.googlecode = '';
      this.qlShow = false;
    })
  }
  showMerchantStatistics(id) {
    this.sub_id = id;
    this.merchantStatisticsShow = true
  }

  agentIdchange(e) {
    if (e) {
      this.input.agentId = this.agents.find(x => x.id == e).id;
    } else {
      this.input.agentId = null;
    }
  }
  qlGoogleCode() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.qlShow = true;
    this.googlecode = '';
  }
  merCreateQunTieCode(){
    if(this.selectedDataItems.length == 0)
    {
      this.$Notice.error({title:"请选择数据"});
      return;
    }
    if(this.selectedDataItems.length > 1){
      this.$Notice.error({title:"只能选中一条数据"});
      return;
    }
    this.mershouyintaicode= "";
    let req = this.selectedDataItems[0].id;
    this.prox.createMerchantCheckoutCounter(req).then(x=>{
          this.mershouyintaicode = x;
          this.merquntiecodeshow = true;
          this.$nextTick(() => {          // 等待 Modal 内的 canvas 渲染完成
      const canvas = this.$refs.canvasRef as HTMLCanvasElement;
      if (!canvas) {
        console.error("canvas 元素未找到");
        return;
      }
      const opts = {
        errorCorrectionLevel: 'H',
        width: 200,
      };
      QRCode.toCanvas(canvas, this.mershouyintaicode, opts, (error) => {
        if (error) console.error(error);
        // 如果需要绘制 Logo，可以在这里添加
        const ctx = canvas.getContext('2d');
        // 注意：这里需要确保 Logo 图片已加载，并且不会跨域
        // 如果不需要 Logo，可以删除下面这段
        const img = new Image();
        // img.src = '/path-to-your-logo.png';
        img.onload = () => {
          const size = 50;
          const x = (canvas.width - size) / 2;
          const y = (canvas.height - size) / 2;
          ctx.drawImage(img, x, y, size, size);
        };
      });
    });
    })
  }
  BatchGroupMark() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            placeholder: '批量修改群标志'
          },
          on: {
            input: (val) => {
              this.groupMark = val
            }
          }
        })
      },
      onOk: () => {
        let ids = new proxy.MerchantUpdateGroupMarkDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id
        })
        ids.groupMark = this.groupMark
        this.prox.updateGroupMark(ids).then(x => {
          this.$Notice.success({ title: '批量修改群标志成功' })
          this.getpage()
        })
      }
    })
  }

  okSettlement() {
    this.prox.settlement(this.settlementreq).then(x => {
      this.$Notice.success({ title: '商户结算中,请不要重复点击' });
      this.getpage();
      this.Settlementshow = false;

    })
  }
  presettlement() {
    this.prox.settlementPre(this.settlementreq).then((x) => {
      this.settlementPredatas = x;
    });
  }
  openSettlementPre() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.settlementreq = new proxy.SettlementPreMerInputDto();
    this.settlementPredatas = new proxy.SettlementPreOutDto();
    this.settlementreq.merIds = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.Settlementshow = true;
  }
  ApiStatusChange(row) {
    let req = new proxy.IdsDto();
    req.idList = [row.id];
    this.prox.batchApiStatusChange(row.isEnableApi, req).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  BatchApiStatusChange(e) {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.batchApiStatusChange(e, req).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  StatusChange(row) {
    let req = new proxy.IdsDto();
    req.idList = [row.id];
    this.prox.batchStatusChange(row.status == 0 ? 1 : 0, req).then((x) => {
      this.dataList=[];
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  loginWhiteLimitChange(row) {
    let req = new proxy.IdsDto();
    req.idList = [row.id];
    this.prox.loginWhiteLimitChange(row.isLoginWhiteLimit, req).then(x => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    })
  }
  BatchStatusChange(e) {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.batchStatusChange(e, req).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  copydoc() {
    let str2 = `商户名称：${this.apidocmodel.merchantName}
商户后台：${this.apidocmodel.merchantUrl}
登录账号：${this.apidocmodel.userName}
初始密码：${this.apidocmodel.loginPwd}
商户号：${this.apidocmodel.mid}
商户秘钥：${this.apidocmodel.mSecret}
回调IP：${this.apidocmodel.apiIps}
系统说明：为了账户安全，登录成功后请先修改密码，绑定谷歌验证码。
对接文档：${this.apidocmodel.docUrl}
创建订单：${this.apidocmodel.createOrderUrl}
订单查询：${this.apidocmodel.queryOrderUrl}`;
    this.copyData(str2);
  }
  okladan() {
    new proxy.PayOrderServiceProxy()
      .createOrder(this.testladanreq)
      .then((x) => {
        this.ladanres = x;
        this.$Notice.success({ title: "订单创建成功" });
      });
  }
  ctypechange(e) {
    this.testladanreq.channelTypeCode = e;
    let c = this.ctypes.find((x) => x.code == e);

    this.allchannels = c.channelTypeChannels;
  }

  actionclick(row, e) {
    if (e == 1) {
      this.del(row);
    }
    if (e == 2) {
      this.$Modal.confirm({
        title: "你确定重置登录密码吗?重置后密码为:123456",
        onOk: () => {
          new proxy.UserManageServiceProxy()
            .resetLoginPwd(row.userId)
            .then((x) => {
              this.$Notice.success({ title: "重置成功" });
              this.getpage();
            });
        },
      });
    }
    if (e == 3) {
      this.$Modal.confirm({
        title: "你确定要清除该用户绑定的谷歌验证吗?",
        onOk: () => {
          new proxy.UserManageServiceProxy()
            .clearGoogleKey(row.userId)
            .then((x) => {
              this.$Notice.success({ title: "清除成功" });
              this.getpage();
            });
        },
      });
    }
    if (e == 4) {
      let req = new proxy.MerchantSimpleInputDto();
      req.status = 0;

      this.prox.queryAllList(req).then((x) => {
        this.marchants = x;
      });

      let req2 = new proxy.ChannelTypePageInputDto();
      req2.isEnable = true;
      req2.maxResultCount = 1000;
      req2.sorting = 'code asc, id desc'
      new proxy.ChannelTypeServiceProxy().queryAllTypes(req2).then((x) => {
        this.ctypes = x;
      });

      this.testladanreq.merId = row.id;
      this.testladanshow = true;
    }
    if (e == 5) {
      this.prox.queryMerchantInfo(row.id).then((x) => {
        this.apidocmodel = x;
        this.apidocshow = true;
      });
    }
    if (e == 6) {
      this.$Modal.confirm({
        title: '重置商户密钥',
        content: '确认重置商户密钥吗？',
        onOk: () => {
          this.prox.updateMsecret(row.id).then(x => {
            this.$Notice.success({ title: "密钥重置成功" });
          });
        },
      });
    }
    if (e == 7) {
      new proxy.UserManageServiceProxy().unlockUser(row.userId).then(x => {
        this.$Modal.success({
          title: '解除锁定',
          content: '解除成功，请尝试重新登录'
        })
      })
    }
  }
  adjadvanceMoney(row) {
    this.merchantId = row.id;
    this.AdvanceMoneyAdjustOrdersEditshow = true;
  }
  adjbalance(row) {
    this.merchantId = row.id;
    this.BalanceAdjustOrderEditshow = true;
  }
  isEnableApichange(row) {
    this.prox.createOrUpdate(row).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  statuschange(row, e) {
    if (e) {
      row.status = 0;
    } else {
      row.status = 1;
    }
    return;
    this.prox.createOrUpdate(row).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting
    //this.input.sorting = "Status asc,id desc";
    // let req = new proxy.AgentPageInputDto();
    // req.maxResultCount = 200;
    // req.status = 0;
    this.prox.queryAgentList().then(x => {
      this.agents = x;
    })
    this.prox.queryModelList(this.input).then((x) => {

      this.dataList = x.items;
      this.showPaging(x);
    });
    this.prox.queryModelListTotal(this.input).then((x) => {
      this.total = x;
    });
    let mreq = new proxy.MerchantSimpleInputDto();
      new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
        this.all_merchants = x;
      });
    new proxy.StorageQueryProductChannelServiceProxy().queryAllList().then(x=>{
      this.selectctchannels = x;
    })
  }

  getpage() {
    this.OnInit();
  }
  async created() {
    this.sorting = "Status asc,id desc";
    this.getpage();
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = undefined;
  }
  edit(row) {
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }
  
  MerLoginWhite() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中一条数据" });
      return;
    }
    if (this.selectedDataItems.length >= 2) {
      this.$Notice.error({ title: "请选中一条数据" });
      return;
    }
    this.loginwhiteid = this.selectedDataItems[0].id;
    this.prox.merLoginWhiteLimit(this.selectedDataItems[0].id).then(x => {
      this.MerLoginWhiteIp = x;
    })
    this.loginWhiteShow = true;
  }
  loginwhitesave() {
    this.prox.loginWhiteLimit(this.loginwhiteid, this.MerLoginWhiteIp.loginWhiteList).then(x => {
      this.$Notice.success({ title: "修改成功" });
      this.loginWhiteShow = false;
    })
  }

  del(row) {
    this.$Modal.confirm({
      title: "你确定要删除吗?删除后将无法恢复",
      onOk: () => {
        this.prox.deletes([row.id]).then(() => {
          this.$Notice.success({ title: "删除成功" });
          this.getpage();
        });
      },
    });
  }
}
